import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorytellerSignalSignalService {
  private isValidStoryteller = signal<boolean>(false);

  public set signalIsValidStoryteller(value) {
    this.isValidStoryteller = value;
  }

  public get signalIsValidStoryteller() {
    return this.isValidStoryteller;
  }
}
